import React from "react";
import { withRouter } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";

export const OPEN_MOBILE_MENU = "OPEN_MOBILE_MENU";

const Icon = ({ d }) => (
  <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);

const ICONS = {
  home: "M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z",
  extract: "M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9zM14 3v6h6M8 13h8M8 17h5",
  billing: "M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM3 10h18M7 15h4",
  menu: "M4 7h16M4 12h16M4 17h16",
};

/**
 * App-style bottom navigation, phones only (hidden above 767px by
 * styles/mobile.css). Desktop layout is unchanged.
 */
function MobileTabBar({ location, history }) {
  const { text } = useLanguage();
  const path = location?.pathname || "/";
  React.useEffect(() => {
    document.body.classList.add("has-mobile-tabbar");
    return () => document.body.classList.remove("has-mobile-tabbar");
  }, []);
  const go = (to) => () => {
    if (path !== to) history.push(to);
    window.scrollTo(0, 0);
  };
  const tabs = [
    { key: "home", label: text("ホーム", "Home"), to: "/", active: path === "/" },
    { key: "extract", label: text("抽出", "Extract"), to: "/ocr-extract-view", active: path.startsWith("/ocr-extract-view") },
    { key: "billing", label: text("プラン・請求", "Billing"), to: "/settings/invoice", active: path.startsWith("/settings/invoice") || path.startsWith("/invoice") },
  ];
  return (
    <nav className="mobile-tabbar" aria-label={text("メインメニュー", "Main menu")}>
      {tabs.map((t) => (
        <button key={t.key} type="button" className={"mobile-tab" + (t.active ? " is-active" : "")} onClick={go(t.to)} aria-current={t.active ? "page" : undefined}>
          <Icon d={ICONS[t.key]} />
          <span>{t.label}</span>
        </button>
      ))}
      <button
        type="button"
        className="mobile-tab"
        onClick={() => setTimeout(() => window.dispatchEvent(new Event(OPEN_MOBILE_MENU)), 0)}
      >
        <Icon d={ICONS.menu} />
        <span>{text("メニュー", "Menu")}</span>
      </button>
    </nav>
  );
}

export default withRouter(MobileTabBar);
